import * as Sentry from '@sentry/gatsby'
import { getUserAdminPortal } from '../services/auth'

// Valor de SPAN_STATUS_ERROR en @sentry/core (no lo reexporta @sentry/gatsby).
export const SPAN_STATUS_ERROR = 2

// Al recargar o salir de la página el navegador corta los requests en vuelo y
// llegan como error de red: no es una falla real.
let pageUnloading = false
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    pageUnloading = true
  })
}
export const isPageUnloading = () => pageUnloading

// Solo ids: nombre, email y teléfono del usuario no se envían.
export const syncSentryUser = () => {
  const user = getUserAdminPortal()?.user
  Sentry.setUser(user?.id ? { id: String(user.id) } : null)
  Sentry.setTag('partner_id', user?.partnerId ? String(user.partnerId) : null)
}
